// extracted by mini-css-extract-plugin
module.exports = {"sectionPadding":"styles_sectionPadding__gsWC_","container":"styles_container__2yEgI","dateStrip":"styles_dateStrip__q2Og9","root":"styles_root__v7EL9"};